import { useState } from 'react';
import { withStyles } from '@material-ui/styles';
import { Button, Checkbox, Menu, MenuItem } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import sortBy from 'lodash/sortBy';

const TableColumnView = ({ columnDefs, handleColumnChange }) => {
  const columnsToDisplay = columnDefs.filter((col) => col.headerName !== '');
  const sortedColumns = sortBy(columnsToDisplay, 'headerName');

  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <Button
        data-testid="table-column-view"
        variant="text"
        color="default"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        endIcon={<KeyboardArrowDownIcon />}
      >
        View
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {sortedColumns?.map((col, i) => (
          <MenuItem
            dense
            key={`${i}-${col.field}`}
            onClick={() => handleColumnChange(col.colId, col.hide)}
          >
            <CheckboxWithoutHover
              size="small"
              disableRipple
              color="primary"
              checked={!col.hide}
              data-testid={`checkbox-${col.field}`}
            />
            {col.headerName}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const CheckboxWithoutHover = withStyles({
  root: {
    '&&:hover': {
      backgroundColor: 'transparent',
    },
  },
})(Checkbox);

export default TableColumnView;
